import { Raphael} from 'react-raphael';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getTemplateClusterlets } from '../../../../store/constructs/templated_clusterlet/selectors';
import { getDetailsFromTemplateTransaction } from '../../../../services/templates/index';
import { getClusterlets } from '../../../../store/constructs/clusterlets/selectors';
import { Grid } from '@material-ui/core';
import config from '../../../../config/raphael';
import { eventAttributes, labelAttributes, nestedTransactionLabelConfig } from '../../../../config/clusterlets';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import TransactionZoomOptions from '../../../pages/blueprint/TransactionZoomOptions';

const { default: ImgGrid } = require("./images/grid.gif");

export default function TemplateTransaction( {transaction} ) {

    const [nodes, setNodes] = useState([]);
    const [children,setChildren] = useState({events:[]});
    const templates = useSelector(getTemplateClusterlets);
    const clusterlets = useSelector(getClusterlets);
    
    let style = {
        backgroundImage: `url(${ImgGrid})`,
        overflow: 'scroll',
        border: '2px solid #ccc',
        height: window.screen.height - 230,
        minWidth: window.screen.width - 100,
        //width: this.drawnRectangles.length * (this.widthOfRectangle * 2) + this.widthOfRectangle,
        '-webkit-transform-origin': '0 0',
        width: 5000// this.drawnRectangles.length * transactionWidth
    };

    const { widthOfRectangle, heightOfRectangle, initialYPosition, verticalLineHeight } = config;

    useEffect( () => {
        
        const {nodes, events} = getDetailsFromTemplateTransaction(transaction, templates, clusterlets);
        const updatedNodes = nodes.map((node,key)=>({...node,xPosition: (2*widthOfRectangle * (key+1)) + widthOfRectangle}));

        setNodes(updatedNodes);

        let childEvents = [];
        events.forEach( (event,key) => {

            let position = {
                x1: updatedNodes.find(n=>n.id == event.src.id).xPosition + (widthOfRectangle/2), 
                x2: updatedNodes.find(n=>n.id == event.dst.id).xPosition + (widthOfRectangle/2)
            }

            childEvents.push({...event,position})

        });

        setChildren({events:childEvents})

    },[transaction])

    useEffect( () => {
        initiateDrawing();
    },[nodes])

    const initiateDrawing = () => {

        let canvasEl = document.getElementById('paper-element')
		const paper = Raphael(canvasEl);

        const drawnNodes = [];
        const drawnEvents = [];

        nodes.forEach( node => {
            
            const rect = paper.rect(node.xPosition,initialYPosition,widthOfRectangle,heightOfRectangle, config.rectangle.borderRadius);
            rect.attr(config.nodes);

            drawnNodes.push({obj:node,id:node.id});

            const nodeText = paper.text(node.xPosition + widthOfRectangle/2 ,initialYPosition+30,node.name);

            const nodeVerticalLineProp = `M${node.xPosition+widthOfRectangle/2} ${initialYPosition+heightOfRectangle}L${node.xPosition+widthOfRectangle/2} ${initialYPosition+widthOfRectangle+verticalLineHeight}`;
            const nodeVerticalLine = paper.path(nodeVerticalLineProp);
        });

        children.events.forEach( event => {

            let y = (initialYPosition + heightOfRectangle + 60);

            if(drawnEvents.length > 0) {
                y = drawnEvents[ drawnEvents.length -1 ].obj.attr('y') + 60
            }

            const arrowPath = `M${event.position.x1} ${y}L${event.position.x2} ${y}`;
            const eve = paper.path(arrowPath)
            eve.attr(eventAttributes)
            drawnEvents.push({obj:eve,id:event.id});

            const start = arrowTextPosition(event.position.x1, event.position.x2)
            const eventLabel = paper.text(start, y - config.event.eventLabelGap, event.name);
            eventLabel.attr(labelAttributes);

            let box = eventLabel.getBBox();
		    let rect = paper.rect(box.x - 10, box.y, box.width + 20, box.height).attr(nestedTransactionLabelConfig);
		    eventLabel.toFront();

        })
    }

    const arrowTextPosition = (x1, x2) => {

		if (x2 > x1)
			return x1 + (x2 - x1) / 2
		else
			return x2 + (x1 - x2) / 2

	}
    
    
    return (

        <Grid container xs={12} style={style}>
                <TransformWrapper disabled={false} minScale={0.7} >
                {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                <>
                    <TransformComponent >
                <div id='paper-element' style={{width:style.width,height:style.height}}></div>
                </TransformComponent>
                <TransactionZoomOptions zoomIn={e => { zoomIn() }} zoomOut={e => { zoomOut() }} reset={e => { resetTransform() }} />
                </>
                )}
                </TransformWrapper>
        </Grid> 
    )
}